import script from "./OverlayManager.vue?vue&type=script&setup=true&lang=js"
export * from "./OverlayManager.vue?vue&type=script&setup=true&lang=js"

import "./OverlayManager.vue?vue&type=style&index=0&id=27964ec3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27964ec3"]])

export default __exports__